import React from "react";
import Modules from './module.component';

const AllModules = require("../../../data/module.data");
const ModulesConfig = require("../../../data/configs.data");

interface Props {
  propertyType: any;
  module1: any;
  module2: any;
  module3: any;
  module4: any;
  modulesCompleted: boolean;
  showAlternative: string;
  setModule1: (value: any) => void;
  setModule2: (value: any) => void;
  setModule3: (value: any) => void;
  setModule4: (value: any) => void;
  setShowAlternative: (value: any) => void;
  setModulesCompleted: (value: any) => void;
}

const SidebarModules: React.FC<Props> = ({ propertyType, module1, module2, module3, module4, modulesCompleted, showAlternative, setModule1, setModule2, setModule3, setModule4, setModulesCompleted, setShowAlternative }) => {

  const [activeGroup, setActiveGroup] = React.useState(0);
  const [modulesList, setModulesList] = React.useState<any>([]);
  const [isAlternative, setIsAlternative] = React.useState(false);
  const [availableTypologies, setAvailableTypologies] = React.useState([]);

  const states: any = {
    module1: {
      state: module1,
      setter: setModule1,
    },
    module2: {
      state: module2,
      setter: setModule2,
    },
    module3: {
      state: module3,
      setter: setModule3,
    },
    module4: {
      state: module4,
      setter: setModule4,
    }
  };

  React.useEffect(() => {
    if(propertyType.id){
      const modulesProperty = AllModules.Data[propertyType.id];
      setModule1(null);
      setModule2(null);
      setModule3(null);
      setModule4(null);
      setModulesList(modulesProperty);
    }
  }, [propertyType, setModule1, setModule2, setModule3, setModule4]);

  React.useEffect(() => {
    let completed = true;
    if(modulesList.length === 0)
      return;
    if(modulesList.length > 0){
      completed = completed && (module1 !== null)
    }
    if(modulesList.length > 1){
      completed = completed && (module2 !== null)
    }
    if(modulesList.length > 2){
      completed = completed && (module3 !== null)
    }
    if(modulesList.length > 3){
      completed = completed && (module4 !== null)
    }
    setModulesCompleted(completed);

    let isMorphy = false;
    if(module2 !== null && module2.id === "murphy"){
      isMorphy = true;
    }
    if(module3 !== null && module3.id === "murphy"){
      isMorphy = true;
    }
    setIsAlternative(isMorphy)
    if(isMorphy)
      setShowAlternative("Murphy");
    else
      setShowAlternative("");

  }, [module1, module2, module3, module4, propertyType, modulesList, setModulesCompleted, setShowAlternative]);

  React.useEffect(() => {
    if(modulesList.length === 0)
      return;

    const config = ModulesConfig.Data[propertyType.id];
    let updateConfigs: any = [];
    for(const typology in config){
      updateConfigs.push(config[typology]);
    }

    if(modulesList.length > 1 && module1 !== null){
      const config: any = [];
      for(const localConfig of updateConfigs){
        if(module1.id.toLowerCase().includes(localConfig.module1) ){
          config.push(localConfig);
        }
      }
      updateConfigs = config;
    }
    if(modulesList.length > 2 && module2 !== null){
      const config: any = [];
      for(const localConfig of updateConfigs){
        if(module2.id.toLowerCase().includes(localConfig.module2) ){
          config.push(localConfig);
        }
      }
      updateConfigs = config;
    }
    if(modulesList.length > 3 && module3 !== null){
      const config: any = [];
      for(const localConfig of updateConfigs){
        if(module3.id.toLowerCase().includes(localConfig.module3) ){
          config.push(localConfig);
        }
      }
      updateConfigs = config;
    }
    if(modulesList.length > 4 && module4 !== null){
      const config: any = [];
      for(const localConfig of updateConfigs){
        if(module4.id.toLowerCase().includes(localConfig.module4) ){
          config.push(localConfig);
        }
      }
      updateConfigs = config;
    }
    setAvailableTypologies(updateConfigs);
  }, [module1, module2, module3, module4, propertyType, modulesList, setModulesCompleted, setShowAlternative]);

  return (
    <div className="tour-sidebar-modules-container">
      <div className='tour-sidebar-modules-container-title'>Modulaciones</div>
      <div className='tour-sidebar-modules'>
      {
        modulesList.map( (local_modules: any, index: number) => 
          <Modules key={local_modules.index} module1={module1} module2={module2} module3={module3} module4={module4} modules={local_modules} totalModules={modulesList.length} availableTypologies={availableTypologies}
                   activeGroup={activeGroup} setActiveGroup={setActiveGroup} currentModule={states[local_modules.category]['state']} setCurrentModule={states[local_modules.category]['setter']}/>
        )
      }
      </div>
      <div className={`tour-sidebar-module-alternatives ${isAlternative ? '':'hide'}`}>
        <div className={`tour-sidebar-module-alternative ${showAlternative === "Sofá" ? 'selected':''}`} onClick={()=>setShowAlternative("Sofá")}>
          <div className={`tour-sidebar-module-alternative-text ${showAlternative === "Sofá" ? 'selected':''}`}>Ver Sofá</div>
        </div>
        <div className={`tour-sidebar-module-alternative ${showAlternative === "Murphy" ? 'selected':''}`} onClick={()=>setShowAlternative("Murphy")}>
          <div className={`tour-sidebar-module-alternative-text ${showAlternative === "Murphy" ? 'selected':''}`}>Ver Murphy</div>
        </div>
      </div>
    </div>
  );
};

export default SidebarModules;